import { Kb3dModel } from '../decorators/kb3d-decorator';
import { instanceOf } from '../decorators/model-utils';
import { ISubmeshFeature, IVertexGroup } from '../kb3d-models';
import { Kb3dObject } from '../kb3d-object';
import { Token } from '../token';
import { ALL_GEOMETRY, eMeshChangeTypes } from './feature';
import { UvMapFeature } from './uv-map-feature';

export interface SubmeshData {
    materialIndex: number;
    verticesStart: number;
    verticesCount: number;
    indexStart: number;
    indexCount: number;
}

@Kb3dModel({
    token: Token.SubmeshFeature,
})
export class SubmeshFeature extends UvMapFeature implements ISubmeshFeature {
    static _dependsOn = new Set([eMeshChangeTypes.VertexIndices]);
    static _affects = new Set(ALL_GEOMETRY);
    static _affectedBy = new Set(ALL_GEOMETRY);

    vertexGroups: Array<Required<IVertexGroup>> = [];
    materialId: string;
    uvMapping: boolean;
}

export function isSubmesh(o: Kb3dObject): o is SubmeshFeature {
    return instanceOf(o, Token.SubmeshFeature);
}
